#import "./TrainingCategoryFields.graphql"

mutation CreateTrainingCategory($name: String!) {
  createTrainingCategory(input: { name: $name }) {
    trainingCategory {
      ...TrainingCategoryFields
    }
  }
}
